exports.ATTACHMENT_CONSTANTS = {
    // Aproximadamente 10,5 MB
    MAX_SIZE: 10485760,
};

exports.ATTACHMENT_TYPES = {
    PDF: 'application/pdf',
    EXCEL_2003: 'application/vnd.ms-excel',
    EXCEL_2007: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    WORD_2003: 'doc',
    WORD_2007: 'docx',
    PPT_2003: 'ppt',
    PPT_2007: 'pptx',
    ODT: 'odt',
    TXT: 'text/plain',
    XML: 'xml',
    JPG: 'image/jpg',
    JPEG: 'image/jpeg',
    PGN: 'image/png',
    TIF: 'image/tif',
    GIF: 'image/gif',
    ZIP: 'file/zip',
    RAR: 'file/rar',
    F7Z: 'file/7z',
};

exports.ATTACHMENT_EXTENSIONS = {
    PDF: '.pdf',
    EXCEL_2003: '.xls',
    EXCEL_2007: '.xlsx',
    WORD_2003: '.doc',
    WORD_2007: '.docx',
    PPT_2003: '.ppt',
    PPT_2007: '.pptx',
    ODT: '.odt',
    TXT: '.txt',
    XML: '.xml',
    JPG: '.jpg',
    JPEG: '.jpeg',
    PGN: '.png',
    TIF: '.tif',
    GIF: '.gif',
    ZIP: '.zip',
    RAR: '.rar',
    F7Z: '.7z',
};
